import React from "react";

import Modal from "../../modal";

export default class AdditionalInfoPop extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <>
        <i
          className="fa fa-info-circle text-primary pointer"
          style={{ paddingRight: "2px" }}
          onClick={() => $("#popup-modal").modal("show")}
        ></i>
        <Modal id="popup-modal" title="Notes">
          <div className="row" style={{ margin: "unset" }}>
            <div
              className="col-xs-12 text-left"
              style={{ padding: "0px 10px 10px" }}
            >
              <ul>
                <li>
                  If the service price for this customer has changed, it will be
                  displayed in <span style={{ color: "deeppink" }}>pink</span>.
                </li>
                <li>
                  Currently, the connection between the services defined in the
                  catalog and the services defined for the customer is
                  established by their names. Therefore, if you update the price
                  of a service in the catalog, the price will be updated for all
                  customers, unless the price has already been changed for a
                  specific customer (Overrided).
                </li>
                <li>
                  If the names of the services in the catalog are changed or
                  deleted, the link between them and the services defined for
                  the customer will be lost.
                </li>
              </ul>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
